var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-group"},[_c('span',{staticClass:"option-group__label"},[_vm._v(_vm._s(_vm.label))]),_vm._t("default"),_c('span',{staticClass:"option-group__line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }